<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {computed} from "vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
  connected: {
    type: Boolean,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  connectionUri: {
    type: String,
    required: true
  },
});

const openInNewTab = computed(() => window.location.href.includes('shopify'));
</script>

<template>
  <div class="tw-flex tw-flex-col tw-gap-8 tw-border tw-border-grey-mid tw-rounded-lg tw-p-8">
    <div class="tw-flex tw-justify-between">
      <div class="tw-flex tw-gap-8 tw-items-center">
        <svg-vue
          :icon="icon"
          class="tw-h-8"
        />
        <p class="tw-text-grey-dark tw-text-lg/0">
          {{ title }}
        </p>
      </div>

      <div
        v-if="connected"
        class="tw-flex tw-gap-4 tw-items-center"
      >
        <span class="tw-text-everest-bright tw-text-xl tw-font-bold">
          Connected
        </span>

        <svg-vue
          class="tw-w-8 tw-h-8 tw-text-white tw-bg-everest-bright tw-rounded-full tw-p-1"
          icon="icons/tick-thin"
        />
      </div>

      <DefaultButton
        v-else
        class="tw-w-40"
        as="a"
        :href="connectionUri"
        :target="openInNewTab ? '_blank' : '_self'"
      >
        Connect
      </DefaultButton>
    </div>
  </div>
</template>

